module.exports = __webpack_public_path__ + "static/media/monday.43c7a463.svg";